import React, { useEffect, useRef } from 'react';

import * as d3 from 'd3';

export function ConnectionDonutChart({
  chartKey, className, width, height, lineWidth,
  numberOfConnected, numberOfDisconnected
}) {
  const chartRef = useRef();

  useEffect(() => {
    const outerRadius = height / 2;
    const innerRadius = outerRadius - lineWidth;
    const padAngle = 0.1;

    chartRef.current.innerHTML = "";

    const svg = d3.select(chartRef.current)
      .append("svg").attr("viewBox", [0, 0, width, height])
      .attr("width", width)
      .attr("height", height);

    const data = [numberOfConnected, numberOfDisconnected];
    const pie = d3.pie().padAngle(padAngle); // adjusted pad angle (good)
    const arc = d3.arc()
      .innerRadius(innerRadius)
      .outerRadius(outerRadius)
      .cornerRadius(5);

    const g = svg.selectAll("g")
      .data(() => [pie(data)])
      .join("g")
      // .attr("fill", (d, i) => "steelblue")
      .attr("transform", `translate(${outerRadius}, ${outerRadius})`);

    g.append("g")
      .selectAll("path")
      .data(arcs => arcs)
      .join("path")
      .attr("d", arc.padAngle(padAngle))
      .attr("fill", (d, i) => ["#1DE484", "#ff50a4"][i]);

  }, [chartKey, width, height, lineWidth,
    numberOfDisconnected, numberOfConnected]);


  return (
    <div className={className} ref={chartRef} />
  );
}

/**
  <ConnectionDonutChart
      chartKey="playground-svg" className="playground-svg"
      width={80}
      height={80}
      lineWidth={6}
      numberOfConnected={7} numberOfDisconnected={1}
  />
*/